import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Stack } from '@moda/om';
import { LOW_INVENTORY_AMOUNT } from '../../../constants';
import { LineItem } from '../../../hooks/useCart/cart.rest';
import './LineItemAlerts.scss';

type Props = {
  item: LineItem;
  className?: string;
};

// TODO: These messages should be changed on the backend.
const ERROR_MESSAGE_MAP: { [key: string]: string } = {
  'Please select a  different size.': 'Size sold out: Please select a different size.',
  'Please select a smaller quantity.': 'Not enough units: Please select a smaller quantity.'
};

export const LineItemAlerts: React.FC<Props> = ({
  item: {
    type,
    attributes: { scarcityAlert, skuId, inventory, isProductAvailable, isTrunkshow, error }
  },
  className
}) => {
  const selectedSku = useMemo(() => inventory.find(({ id }) => skuId === id), [skuId, inventory]);

  const lowStockAlert =
    !(type === 'cart_items' && !isProductAvailable) &&
    selectedSku &&
    selectedSku.available > 0 &&
    selectedSku.available <= LOW_INVENTORY_AMOUNT &&
    !isTrunkshow &&
    `Only ${selectedSku?.available} Left!`;

  if (!((isProductAvailable && error) || lowStockAlert || scarcityAlert)) return null;

  return (
    <Stack className={classNames('LineItemAlerts', className)} space={1}>
      {isProductAvailable && error && (
        <div className="LineItemAlerts__alert">
          {ERROR_MESSAGE_MAP[error.message] || error.message}
        </div>
      )}
      {lowStockAlert && <div className="LineItemAlerts__alert">{lowStockAlert}</div>}
      {scarcityAlert && <div className="LineItemAlerts__alert">{scarcityAlert}</div>}
    </Stack>
  );
};
